import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Rangos } from '@pages/fabrica-credito/interfaces/rangos';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { Response } from '@shared/interfaces/response/response';
import { Producto } from '@p-parametria/mantenimiento/abc-empresas/interfaces/producto';
import { ProductoRangos } from '@p-parametria/mantenimiento/abc-empresas/interfaces/productoRangos';
import { Actividades } from '@pages/actividades/interfaces/actividades';


const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};
@Injectable({
  providedIn: 'root'
})
export class ActividadesService {
  private _url = environment.apiBaseUrl + 'api/Actividades/';
  constructor(private _http: HttpClient) { }

  read(perfil : string): Observable<Response> {
    const url = `${this._url}${perfil}`;
    return this._http.get<Response>(url);
  }

  create(model: Actividades): Observable<Response> {
    let url: string = this._url + 'Create' ;
    return this._http.post<Response>(url, model, httpOption);
  }
  update(model: Actividades): Observable<Response> {
    let url: string = this._url + 'Update' ;
    return this._http.put<Response>(url, model, httpOption);
  }

  delete(model: Actividades): Observable<Response> {
    let url: string = this._url + 'Delete' ;
    return this._http.request<Response>('delete', url, {
      body: model,
    });
  }
}
